import * as React from "react";
import { hashHistory } from "react-router";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import { Opportunity } from "../../models/opportunity";
import { ILocalization } from "../../models/localization";
import { OpportunitySummary, CategoryOps } from "../../models/opportunity";
import { SavedOpportunity } from "../../models/profile";
import { SavedOpportunityState } from "../../models/enums";
import { LinearProgress } from "material-ui/Progress";
import { Grid, Row, Col } from "react-flexbox-grid";
import SavedOpCard from "../../components/opportunity/savedOpSummary";
import BackButton from "../../components/widgets/backBtn";
import * as s from "./savedops.css";

@inject("store") @observer
export default class SavedOpsVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount(): void {
    window.scrollTo(0, 0);  
    //this.props.store.viewState.trackView(); //causing refresh to crash
  }
  componentDidMount(): void {
    this.props.store.getHelpTopics();
  }
 
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if (!this.props.store.profileStore.profile) {
      hashHistory.push("/home");
      return;
    } else {
      let imgUrl: string;
      const items: JSX.Element[] = [];
      if (this.props.store.profileStore.profile.savedOps.length === null) {
        return;
      }
      this.props.store.profileStore.profile.savedOps.map((so: SavedOpportunity, i: number): void => {
        if ((so.status & SavedOpportunityState.Saved) > 0) {
          const op: Opportunity = this.props.store.opportunityStore.getOpportunity(so.opportunityId);
          items.push(<SavedOpCard key={"so-" + so.opportunityId} store={this.props.store} op={op} />)
        } 
      });

      if (items.length === 0) {
        items.push(<p className={s.noSavedOps} key="no-saved-ops">{local.noSavedOps}</p>);
      }
    return (
      <Grid fluid>
        <BackButton />
        <Row><Col xs={12}><h4 className={s.header}>{local.savedOps}</h4></Col></Row>
        <Row>{items}</Row>
        </Grid>);
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/savedOps/index.tsx